<template>
  <el-dialog
    title="提醒配置"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    top="10vh"
    :close-on-click-modal="false"
  >
    <div class="top">
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
    <div>
      <el-row>
        <el-col :span="24" :lg="12">
          <el-card>
            <div
              style="
                font-weight: bolder;
                font-size: initial;
                padding-top: 10px;
                padding-bottom: 15px;
              "
            >
              提醒名称:
            </div>
            <el-tree
              ref="dingConfigTree"
              :data="itemList"
              :props="defaultProps"
              :highlight-current="true"
              class="filter-tree"
              node-key="ID"
              @node-click="clickNode"
            ></el-tree>
          </el-card>
        </el-col>
        <el-col :span="24" :lg="12">
          <el-card>
            <el-tabs
              v-model="activeTab"
              type="border-card"
              @tab-click="changeTab"
            >
              <el-tab-pane label="按角色" name="tabRole">
                <el-tree
                  ref="roleTree"
                  :props="roleProps"
                  :data="roleList"
                  node-key="ID"
                  show-checkbox
                  @check="roleCheckChange"
                >
                </el-tree
              ></el-tab-pane>
              <el-tab-pane label="按用户" name="tabUser"
                ><el-tree
                  ref="userTree"
                  :props="userProps"
                  :data="userList"
                  node-key="ID"
                  show-checkbox
                  @check="userCheckChange"
                >
                </el-tree
              ></el-tab-pane>
            </el-tabs>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      itemList: [],
      userList: [],
      roleList: [],
      pager: {
        total: 0,
        page: 1,
        size: -1,
      },
      defaultProps: {
        label: "Name",
        children: null,
        ID: "ID",
      },
      userProps: {
        label: "Name",
        children: null,
        ID: "ID",
      },
      roleProps: {
        label: "Name",
        children: "Children",
        ID: "ID",
      },
      submitting: false,
      activeData: {}, //当前选中的节点信息
      activeTab: "tabRole",
      userSelectIDs: [],
      roleSelectIDs: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.getItemList();
      this.getUserList();
      this.getRoleList();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.activeData = {};
      this.activeTab = "tabRole";
      this.userSelectIDs = [];
      this.roleSelectIDs = [];

      this.$refs.userTree.setCheckedKeys([]);
      this.$refs.roleTree.setCheckedKeys([]);
    },
    getItemList() {
      //获取列表
      this.$axios
        .get("dingtalkconfig", {
          params: {
            with: ["Users"],
            ...this.pager,
            order: ["name"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;

          //当选中的树节点保存信息后刷新数据并节点高亮处理
          if (this.activeData.ID) {
            this.$nextTick(() => {
              this.itemList.forEach((item) => {
                if (item.ID === this.activeData.ID) {
                  this.activeData = item;
                  this.$refs.dingConfigTree.setCurrentKey(item);
                }
              });
            });
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getUserList() {
      //获取列表
      this.$axios
        .get("user", {
          params: {
            ...this.pager,
            order: ["name"],
          },
        })
        .then((response) => {
          this.userList = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getRoleList() {
      //获取列表
      this.$axios
        .get("role_user_tree")
        .then((response) => {
          this.roleList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    //点击树节点
    clickNode(data) {
      let ischanged = false;
      if (this.activeData === [] || this.activeData.ID != data.ID) {
        ischanged = true;
      }
      this.activeData = data;

      if (ischanged) {
        //左边钉钉配置树节点点击有变化，右边全部重新加载
        this.$nextTick(() => {
          this.$refs.userTree.setCheckedKeys([]);
          this.userSelectIDs = [];
          data.Users.forEach((user) => {
            this.userSelectIDs.push(user.ID);
          });
          this.$refs.userTree.setCheckedKeys(this.userSelectIDs);
        });

        this.$nextTick(() => {
          this.$refs.roleTree.setCheckedKeys([]);

          this.roleSelectIDs = [];
          data.Users.forEach((user) => {
            this.roleSelectIDs.push(user.ID);
            var node = this.$refs.roleTree.getNode(user.ID);
            if (node.isLeaf) {
              this.$refs.roleTree.setChecked(node, true);
            }
          });
          // this.$refs.roleTree.setCheckedKeys(this.roleSelectIDs);
          
        });
      }
    },

    // 切换model
    changeTab(tab) {
      this.activeTab = tab.name;
    },

    //按用户-选择变化
    userCheckChange(data, obj) {
      this.userSelectIDs = obj.checkedKeys;
    },

    //按角色-选择变化
    roleCheckChange(data, obj) {
      this.roleSelectIDs =[];
      obj.checkedNodes.forEach((node) => {
         if (node.Step !== 1) {
           this.roleSelectIDs.push(node.ID);
         }
      });
      // if (checked) {
      //   //选中
      //   if (data.Step === 1) {
      //     //选中根节点
      //     data.Children.forEach((user) => {
      //       if (this.roleSelectIDs.findIndex((id) => user.ID === id) === -1) {
      //         this.roleSelectIDs.push(user.ID);
      //       }
      //     });
      //   } else {
      //     //选中子节点
      //     if (this.roleSelectIDs.findIndex((id) => data.ID === id) === -1) {
      //       this.roleSelectIDs.push(data.ID);
      //     }
      //   }
      // } else {
      //   //取消选中
      //   if (data.Step === 1) {
      //     //选中根节点
      //     data.Children.forEach((user) => {
      //       this.roleSelectIDs.splice(
      //         this.roleSelectIDs.findIndex((id) => user.ID === id),
      //         1
      //       );
      //     });
      //   } else {
      //     this.roleSelectIDs.splice(
      //       this.roleSelectIDs.findIndex((id) => data.ID === id),
      //       1
      //     );
      //   }
      // }
    },

    onSubmit() {
      this.submitting = true;
      // 保存的操作
      this.$axios
        .request({
          url: "dingtalkconfig/config",
          method: "post",
          data: {
            configid: this.activeData.ID,
            uids:
              this.activeTab === "tabUser"
                ? this.userSelectIDs
                : this.roleSelectIDs,
          },
        })
        .then(() => {
          this.$message.success("保存成功");
          this.getItemList();
          this.$emit("form:saved", true);
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.$emit("form:saved", false);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-tree {
  min-width: 100%;
  display: inline-block;
}
.tree {
  overflow: auto;
  max-height: 200px;
}
.top {
  text-align: left;
  background-color: #f5f7fa;
  height: 30px;
  padding: 5px 20px 5px 20px;
  margin: -30px -20px 10px -20px;
}
</style>
